// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1VYLv","footer":"ModalError_footer__1sPpC"};